import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { ImportIcon, MoveGroupsAndAppsIcon, TrashIcon, TagIcon } from '../../components/icons';
// Nouns used by TopBar to build tooltip text for selection-dependent buttons.
export const SOURCE_RESOURCE_NOUNS = { selectNoun: 'sources', countNoun: 'source' };
// TopBar config for the "Manage Sources" identity of the /sources page.
export const SOURCE_INVENTORY_PRIMARY_BUTTONS_CONFIG = [
    { key: 'addSource', buttonText: 'Add Source', icon: <PlusOutlined /> },
    { key: 'csvSources', buttonText: 'CSV Sources', icon: <ImportIcon appIconSmall /> },
    { key: 'importFromDiscovery', buttonText: 'Import from Discovery' },
    { key: 'vmBasedImport', buttonText: 'VM Based Import' },
];
// TopBar config for the "Start Migration" identity of the /sources page.
// selectionDependent buttons are disabled until at least one row is selected,
// and get a tooltip explaining why (via actionLabel + TopBar's applyButtonState).
export const START_MIGRATION_PRIMARY_BUTTONS_CONFIG = [
    {
        key: 'inspectAndMigrate',
        buttonText: 'Inspect & Migrate',
        selectionDependent: true,
        actionLabel: 'configure migration',
        actionConnector: 'for',
    },
    { key: 'runCsvMigration', buttonText: 'Run CSV Migration' },
    {
        key: 'modernizeInPlace',
        buttonText: 'Modernize In Place',
        selectionDependent: true,
        actionLabel: 'modernize in place',
        actionConnector: 'for',
    },
];
// Secondary (bulk selection) icon buttons for the TopBar - shared by both identities.
export const SECONDARY_BUTTONS_CONFIG = [
    {
        key: 'addTags',
        icon: <TagIcon appIconSmall />,
        color: 'primary',
        variant: 'outlined',
        size: 'middle',
        actionLabel: 'add tags',
        actionConnector: 'to',
    },
    {
        key: 'assignMoveGroup',
        icon: <MoveGroupsAndAppsIcon appIconSmall />,
        color: 'primary',
        variant: 'outlined',
        size: 'middle',
        actionLabel: 'assign move group',
        actionConnector: 'to',
    },
    { key: 'delete', icon: <TrashIcon />, danger: true, size: 'middle', actionLabel: 'delete' },
];
